/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PatchEntryResponse = {
    properties: {
        id: {
            type: 'string',
            format: 'uuid4',
        },
        timestamp: {
            type: 'string',
            format: 'date-time',
        },
        userId: {
            type: 'number',
            isRequired: true,
        },
        action: {
            type: 'TeamPatchAuditLogEnum',
            isRequired: true,
        },
        payload: {
            type: 'any-of',
            contains: [{
                type: 'TeamPatch',
            }, {
                type: 'TeamPatchAdmin',
            }, {
                type: 'LocationPatch',
            }, {
                type: 'SponsorPatch',
            }, {
                type: 'SponsorCreate',
            }, {
                type: 'SponsorDelete',
            }, {
                type: 'LocationAdd',
            }, {
                type: 'LocationDelete',
            }, {
                type: 'SuccessPatch',
            }, {
                type: 'SuccessCreate',
            }, {
                type: 'SuccessDelete',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        oldData: {
            type: 'any-of',
            contains: [{
                type: 'TeamPatch',
            }, {
                type: 'TeamPatchAdmin',
            }, {
                type: 'LocationPatch',
            }, {
                type: 'SponsorPatch',
            }, {
                type: 'SponsorCreate',
            }, {
                type: 'SponsorDelete',
            }, {
                type: 'LocationAdd',
            }, {
                type: 'LocationDelete',
            }, {
                type: 'SuccessPatch',
            }, {
                type: 'SuccessCreate',
            }, {
                type: 'SuccessDelete',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        user: {
            type: 'UserSmall',
            isRequired: true,
        },
    },
} as const;
